<template>
  <div>
    <div class="mb-4 pt-3 pb-2">
      <div class="row">
        <div class="col-md-8 mb-3">
          <b-input-group>
            <b-input-group-text slot="prepend" class="bg-shade-1">
              <i class="fa fa-search"></i>
            </b-input-group-text>
            <b-input
              placeholder="Search by name, keyword or mathematical classification number"
              v-model="search"
              autocomplete="off"
              data-lpignore="true"
              @input="filteredPastWorkshopsList('search')"
            />
          </b-input-group>
        </div>
        <div class="col-md-4">
          <multiselect
            v-model="multipleValue"
            :options="yearList"
            :multiple="true"
            :show-labels="false"
            placeholder="Past Workshop Year"
            @input="filteredPastWorkshopsList('search')"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-md-border mb-5">
        <div class="mb-5">
          <div class="lyon-display-medium-24">Past</div>
          <div v-if="loadingPastWorkshopProgram" >
            <generic-loader />
          </div>
          <div v-else>
            <div v-if="pastWorkshopData.length === 0">
              <span class="text-muted regular-14">No result</span>
            </div>
            <div v-else>
              <div class="main-content">
                <div v-for="item in pastWorkshopData" :key="item.id">
                  <div @click="fetchSelectedEvent(item.id, 'workshop-past-grid-dtl-id', 'workshops')" class="cursor-pointer">
                    <left-grid-event-list
                      :event-item="item"
                      :active-item-id="activeItemId"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-shrink-0 mt-3">
                <b-pagination
                  pills
                  :total-rows="pagination.total_rows"
                  v-model="currentPage"
                  @input="filteredPastWorkshopsList('pagination')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-md-border right-side-program-section" id="workshop-past-grid-dtl-id">
        <b-card class="sticky-content" v-if="showDetails">
          <right-grid-event-detail
            :selected-event="selectedEvent"
            :active-item-id="activeItemId"
            :button-name="'VIEW WORKSHOP DETAILS'"
            :page-name="'workshop-details'"
          />
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { scrollToElementId } from '@/utils/CommonUtils.js'
import GenericLoader from '@/components/Loaders/GenericLoader.vue'
import mixin from '@/utils/mixin.js'
import LeftGridEventList from '@/components/CommonPages/LeftGridEventList.vue'
import RightGridEventDetail from '@/components/CommonPages/RightGridEventDetail.vue'
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'PastWorkshopTab',
  props: ['workshopType'],
  components: { Multiselect,GenericLoader, LeftGridEventList, RightGridEventDetail },
  mixins: [mixin],
  data () {
    return {
      search: '',
      selectedEvent: {},
      showDetails: false,
      activeItemId: '',
      year: '',
      multipleValue: [],
      pastWorkshopData: [],
      loadingPastWorkshopProgram: true,
      currentPage: 1,
      pagination: {},
      yearList: []
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  watch: {
    isAuthenticated() {
      this.loadPastWorkshop()
    }
  },
  created () {
    this.loadPastWorkshop()
  },
  methods: {
    loadPastWorkshop () {
      this.showDetails = false
      this.$http.get(process.env.VUE_APP_API_URL + '/workshops/past.json', {
        params: {
          search_value: this.search.toLowerCase(),
          page: this.currentPage,
          year: this.multipleValue
        }
      })
      .then((res) => {
        this.pastWorkshopData = res.data.past.results
        this.pagination = res.data.past.pagination
        this.yearList = res.data.years
        this.loadingPastWorkshopProgram = false
      })
    },
    filteredPastWorkshopsList: debounce(function(val) {
      this.showDetails = false
      this.loadingPastWorkshopProgram = true
      scrollToElementId('workshop-tab-id')
      if(val === 'search'){
        this.currentPage = 1
      }
      const searchValue = this.search.toLowerCase();
      this.$http.get(process.env.VUE_APP_API_URL + '/workshops/search.json', {
      params: {
        search_value: searchValue,
        page: this.currentPage,
        year: this.multipleValue
      }
      })
      .then((res) => {
        this.pastWorkshopData = res.data.past.results
        this.pagination = res.data.past.pagination
        this.loadingPastWorkshopProgram = false
      })
    }, 800)
  }
}
</script>
